import React from "react";
import { IoClose, IoCloseSharp } from "react-icons/io5";

const DefaultRefundRulesModal = ({ isOpen, onClose }) => {
  const rules = [
    {
      cutoff: "8+ days",
      feeType: "Flat",
      feeAmount: "R10",
    },
    {
      cutoff: "4–7 days",
      feeType: "Flat",
      feeAmount: "R20",
    },
    {
      cutoff: "1–3 days",
      feeType: "Flat + Percent",
      feeAmount: "R15 + 25%",
    },
    {
      cutoff: "0 days",
      feeType: "None",
      feeAmount: "No refunds permitted",
    },
  ];

  return (
    <>
      {isOpen && <div className="modal-overlay fade-in"></div>}

      <div
        className={`modal-wrapper modal fade ${isOpen ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content border-0 shadow">
            <div className="modal-header text-black">
              <h5 className="modal-title">Karamale Default Refund Rules</h5>
              <span className="cursor-pointer" onClick={onClose}>
                <IoCloseSharp size={25} />
              </span>
            </div>

            <div className="modal-body">
              <p className="mb-3 text-muted">
                These fallback rules apply when no custom refund tiers are
                configured. Organizers can override them anytime.
              </p>

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Cutoff Days</th>
                      <th>Fee Type</th>
                      <th>Fee Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rules.map((rule, index) => (
                      <tr key={index}>
                        <td>{rule.cutoff}</td>
                        <td>{rule.feeType}</td>
                        <td>{rule.feeAmount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <p className="text-muted small fst-italic">
                These rules are enforced by default to ensure transparency and
                consistency across all events.
              </p>
            </div>

            <div className="modal-footer">
              <button type="button" className="save-btn" onClick={onClose}>
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DefaultRefundRulesModal;
